import { ApiService } from "./ApiService";

export class PppoeProfileService {
  static uri = "/pppoe-profile";

  /* ============================================
     HELPERS
     ============================================ */
  static getHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token-radiustrend")}`,
    };
  }

  /* ============================================
     GET - List dengan filter & pagination
     ============================================ */
  static get(params = {}) {
    const query = new URLSearchParams();

    if (params.search) query.append("search", params.search);
    if (params.type) query.append("type", params.type);
    if (params.mac_lock !== undefined) query.append("mac_lock", params.mac_lock);
    if (params.price_min !== undefined) query.append("price_min", params.price_min);
    if (params.price_max !== undefined) query.append("price_max", params.price_max);
    if (params.validity_unit) query.append("validity_unit", params.validity_unit);
    if (params.sort_by) query.append("sort_by", params.sort_by);
    if (params.sort_dir) query.append("sort_dir", params.sort_dir);
    if (params.per_page) query.append("per_page", params.per_page);
    if (params.page) query.append("page", params.page);

    const queryString = query.toString();
    const url = queryString ? `${this.uri}?${queryString}` : this.uri;

    return ApiService.get(url, { headers: this.getHeaders() });
  }

  /* ============================================
     GET - Detail by ID
     ============================================ */
  static getById(id) {
    return ApiService.get(`${this.uri}/${id}`, { headers: this.getHeaders() });
  }

  /* ============================================
     GET - Options (untuk dropdown/select)
     ============================================ */
  static getOptions(params = {}) {
    const query = new URLSearchParams();
    if (params.type) query.append("type", params.type);

    const queryString = query.toString();
    const url = queryString ? `${this.uri}/options?${queryString}` : `${this.uri}/options`;

    return ApiService.get(url, { headers: this.getHeaders() });
  }

  /* ============================================
     GET - Grouped by type
     ============================================ */
  static getGroupedByType() {
    return ApiService.get(`${this.uri}/grouped`, { headers: this.getHeaders() });
  }

  /* ============================================
     POST - Create
     ============================================ */
  static create({ data }) {
    return ApiService.post(`${this.uri}/create`, data, { headers: this.getHeaders() });
  }

  /* ============================================
     PUT - Update
     ============================================ */
  static update({ id, data }) {
    return ApiService.put(`${this.uri}/${id}`, data, { headers: this.getHeaders() });
  }

  /* ============================================
     PATCH - Update partial
     ============================================ */
  static patch({ id, data }) {
    return ApiService.patch(`${this.uri}/${id}`, data, { headers: this.getHeaders() });
  }

  /* ============================================
     DELETE - Single
     ============================================ */
  static delete({id}) {
    return ApiService.delete(`${this.uri}/delete/${id}`, { headers: this.getHeaders() });
  }

  /* ============================================
     DELETE - Bulk (banyak sekaligus)
     ============================================ */
  static bulkDelete({ ids }) {
    return ApiService.delete(`${this.uri}/bulk`, {
      headers: this.getHeaders(),
      data: { ids },
    });
  }

  /* ============================================
     POST - Duplicate
     ============================================ */
  static duplicate(id) {
    return ApiService.post(`${this.uri}/${id}/duplicate`, {}, { headers: this.getHeaders() });
  }
}